import { render, staticRenderFns } from "./commission.vue?vue&type=template&id=34375698&"
import script from "./commission.vue?vue&type=script&lang=js&"
export * from "./commission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports